var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.925 18.3333H5.075C3.65 18.3333 2.5 17.1499 2.5 15.6999V8.44992C2.5 7.39159 2.98334 6.40825 3.83334 5.75825L8.55001 2.13325C9.43334 1.52492 10.5667 1.52492 11.4167 2.10825L16.1667 5.75825C17.0167 6.40825 17.5 7.39159 17.5 8.44992V15.6999C17.5 17.1499 16.3417 18.3333 14.925 18.3333ZM10.0167 3.33325C9.84999 3.33325 9.67499 3.38325 9.52499 3.48325L4.85001 7.08325C4.41667 7.41659 4.16667 7.91659 4.16667 8.44992V15.6999C4.16667 16.2332 4.575 16.6666 5.075 16.6666H14.925C15.425 16.6666 15.8333 16.2332 15.8333 15.6999V8.44992C15.8333 7.90825 15.5833 7.41659 15.15 7.08325L10.4333 3.45825C10.3167 3.37492 10.1667 3.33325 10.0083 3.33325H10.0167Z",
    fill: "#1E293B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e2cc0adc3e267dce3a892370c1f278c1.svg";
export { ForwardRef as ReactComponent };